/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const accountModule = require('@utils/account/accountModule');
const analyticsModule = require('@utils/analytics/analyticsModule');
const cmsModule = require('@utils/cms/cmsModule');
const commonModule = require('@utils/common/commonModule');
const disclosuresModule = require('@utils/disclosures/disclosuresModule');
const homeAdvisorModule = require('@utils/home_advisor/homeAdvisorModule');
const thirdPartyIntegrationDirective = require('./thirdPartyIntegrationDirective');
const thirdPartyCalloutDirective = require('./thirdPartyCalloutDirective');
const ThirdPartyCalloutService = require('./thirdPartyCalloutService');

const thirdPartyIntegrationModule = angular
    .module('enervee_utils.third_party_integrations', [
        accountModule.name,
        analyticsModule.name,
        cmsModule.name,
        commonModule.name,
        disclosuresModule.name,
        homeAdvisorModule.name
    ])
    .factory('ThirdPartyCalloutService', ThirdPartyCalloutService)
    .directive('thirdPartyIntegration', thirdPartyIntegrationDirective)
    .directive('thirdPartyCallout', thirdPartyCalloutDirective);

module.exports = thirdPartyIntegrationModule;